import React, { useState, useEffect } from 'react';
import './AlphabetPuzzle.css';
import AlphabetNav from './AlphabetNav';


const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const gridSize = 3;
const totalTiles = gridSize * gridSize;

const AlphabetPuzzle = ({ letter, word, imageSrc }) => {
  const [voice, setVoice] = useState('female');
  const [imageSolved, setImageSolved] = useState(false);
  const [tiles, setTiles] = useState([]);
  const [selected, setSelected] = useState(null);
  const [scrambledLetters, setScrambledLetters] = useState([]);
  const [wordSolved, setWordSolved] = useState(false);
  const [resizedImageUrl, setResizedImageUrl] = useState(null);

  useEffect(() => {
    const tileArray = Array.from({ length: totalTiles }, (_, i) => i);
    setTiles(shuffleArray(tileArray));
    setScrambledLetters(shuffleArray(word.toUpperCase().split('')));
  }, [word]);

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = imageSrc;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 300;
      const ctx = canvas.getContext('2d');
      const aspect = img.width / img.height;
      let sx = 0, sy = 0, sWidth = img.width, sHeight = img.height;

      if (aspect > 1) {
        sWidth = img.height;
        sx = (img.width - sWidth) / 2;
      } else if (aspect < 1) {
        sHeight = img.width;
        sy = (img.height - sHeight) / 2;
      }

      ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, 300, 300);
      setResizedImageUrl(canvas.toDataURL());
    };
  }, [imageSrc]);

  const handleTileClick = (index) => {
    if (selected === null) {
      setSelected(index);
    } else {
      const newTiles = [...tiles];
      [newTiles[selected], newTiles[index]] = [newTiles[index], newTiles[selected]];
      setTiles(newTiles);
      setSelected(null);
      if (newTiles.every((val, idx) => val === idx)) {
        setImageSolved(true);
        new Audio(`/assets/audio/a_word_${voice}.mp3`).play();
      }
    }
  };

  const handleLetterClick = (index) => {
    if (selected === null) {
      setSelected(index);
    } else {
      const newLetters = [...scrambledLetters];
      [newLetters[selected], newLetters[index]] = [newLetters[index], newLetters[selected]];
      setScrambledLetters(newLetters);
      setSelected(null);
      if (newLetters.join('') === word.toUpperCase()) {
        setWordSolved(true);
      }
    }
  };

  return (
    <main className="alphabet-puzzle">
      {!imageSolved && (
        
        <div className="audio-instruction">
        <AlphabetNav /> 
          <h2>How to play!</h2>
          <ul>
            <li>Swap the pieces to complete the picture.</li><li> Tap one square, then another to swap them!</li>
            <li>If a tile is in the correct position, it will be framed by a green border.</li>
            <li>Continue swapping tiles until the puzzle is complete.</li>
          </ul>
          <button className="play-prompt" onClick={() => new Audio(`/assets/audio/swap_instructions_${voice}.mp3`).play()}>
            🔊 Hear Instructions
          </button>
        </div>
      )}

      <h1>{letter} is for {word}</h1>

      <div className="voice-selector">
        <label>Select a voice: </label>
        <select value={voice} onChange={(e) => setVoice(e.target.value)}>
          <option value="female">👩 Female</option>
          <option value="male">👨 Male</option>
        </select>
      </div>

      {!imageSolved ? (
        <div className="image-grid">
          {tiles.map((tile, idx) => (
            <div
              key={idx}
              className={`tile${tiles[idx] === idx ? ' correct' : ''}`}
              onClick={() => handleTileClick(idx)}
              style={{
                backgroundImage: resizedImageUrl ? `url(${resizedImageUrl})` : 'none',
                backgroundPosition: `-${(tile % gridSize) * 100}px -${Math.floor(tile / gridSize) * 100}px`,
                backgroundSize: '300px 300px'
              }}
            ></div>
          ))}
        </div>
      ) : !wordSolved ? (
        <>
          <img src={resizedImageUrl} alt={word} width="300" height="300" style={{ margin: '1rem auto', display: 'block' }} />
          <p className="audio-instruction">Can you spell {word}? Put the letters in the correct order to spell Apple. A - P - P - L - E. </p>
          <button className="play-prompt" onClick={() => new Audio(`/assets/audio/a_prompt_${voice}.mp3`).play()}>
            🔊 Hear the Prompt
          </button>
          <div className="letter-grid">
            {scrambledLetters.map((ch, i) => (
              <div
                key={i}
                className={`letter${scrambledLetters[i] === word.toUpperCase()[i] ? ' correct' : ''}`}
                onClick={() => handleLetterClick(i)}
              >
                {ch}
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <img src={resizedImageUrl} alt={word} width="300" height="300" style={{ margin: '1rem auto', display: 'block' }} />
          <h2>Great job! You spelled {word}!</h2>
        </>
      )}
    </main>
  );
};

export default AlphabetPuzzle;
